<template>
  <div class="disclaimer">
    <h3>{{ $t('bounties.redeemDisclaimerTitle') }}</h3>
    <template v-if="mobileAppAvailable">
      <div v-html="$t('bounties.redeemDisclaimerDescription')" />
      <div class="qr-code-container">
        <qrcode
          :value="qrCodeValueOverride || qrCodeValue"
          :options="qrCodeOptions"
        />
      </div>
    </template>
    <template v-else>
      <p>{{ $t('bounties.redeemAppNotAvailable') }}</p>
    </template>
  </div>
</template>

<script>
import _ from 'lodash'
import {mapGetters} from 'vuex'

export default {
  data() {
    return {
      qrCodeOptions: {
        width: 120,
        margin: 0
      },
    }
  },
  computed: {
    ...mapGetters(['clientSlug', 'extensionSettings']),
    qrCodeValue() {
      return `https://api.helloagain.at/app/${this.clientSlug}/c/app/`
    },
    qrCodeValueOverride() {
      return _.get(
        this.extensionSettings, 'loyalty.disclaimer_qr_code_url', ''
      )
    },
    mobileAppAvailable() {
      return _.get(this.extensionSettings, 'webview.mobile_app_available', true)
    }
  },
}
</script>

<style lang="scss" scoped>
.qr-code-container {
  padding-top: 16px;
}
</style>
